var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"passed-badge"},[_c('div',{staticClass:"scale-container"},[_vm._l((_vm.visiblePeople),function(p,i){return _c('span',{key:i,staticClass:"round-badge"},[_vm._v(_vm._s(_vm.getLastName(p)))])}),(_vm.passedList.length > 3)?_c('span',{staticClass:"round-badge"},[_vm._v("...")]):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }